// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const DutySingle = () => {
//   // Extracting dutyId using regular expressions
//   const location = useLocation();
//   // const dutyId = location.pathname.match(/\/class\/(\d+)/);
//   const dutyId = location.pathname.match(/\/duty\/(\d+)/)?.[1];

//   const [duty, setDuty] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchClass = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/duty/${dutyId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setDuty(data);
//       localStorage.setItem("dutyData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (dutyId) {
//       fetchClass();
//     }
//   }, [dutyId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Duty Details</h1>
//                 <div className="details">
//                   {/* <h1 className="itemTitle">{class?.data.name}</h1> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{duty?.data.id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{duty?.data.center_id}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">User: </span>
//                     <span className="itemValue">{duty?.data.user_names}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Job: </span>
//                     <span className="itemValue">{duty?.data.job}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Date: </span>
//                     <span className="itemValue">{duty?.data.date}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Time: </span>
//                     <span className="itemValue">{duty?.data.duty_time}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Description: </span>
//                     <span className="itemValue">{duty?.data.description}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{duty?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default DutySingle;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const DutySingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dutyId = location.pathname.match(/\/duty\/(\d+)/)?.[1];
  const [duty, setDuty] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchDuty = async () => {
    try {
      const response = await fetch(`${serverUrl}/duty/${dutyId}`);
      const data = await response.json();
      setDuty(data);
      localStorage.setItem("dutyData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (dutyId) {
      fetchDuty();
    }
  }, [dutyId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Duty Details</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Duty Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Duty Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Duty Basic Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {duty?.data.job}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {duty?.data.user_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">
                              Assigned To:
                            </span>
                            <span className="font-medium">
                              {duty.data.user_names}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Duty Schedule */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Schedule Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {duty?.data.date && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Date
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {duty.data.date}
                        </p>
                      </div>
                    )}

                    {duty?.data.duty_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Time
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {duty.data.duty_time}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Duty Description */}
                {duty?.data.description && (
                  <div className="bg-white rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                      Description
                    </h3>
                    <p className="text-gray-800 bg-gray-50 rounded-lg p-4">
                      {duty.data.description}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DutySingle;
